module.exports = __webpack_public_path__ + "static/media/Abel-Regular.1052d6ca.ttf";